export default __webpack_public_path__ + "static/media/freezers.6708a124.png";